import OrganizationRequestAccess from '../../views/OrganizationRequestAccess';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';
import { useApiClients } from '../../client/api/useApiClient';
import { GetRequestAccessResponse, OnboardOrganizationControllerGetRequestAccessStatusEnum } from '@EHSNavigator/backend';

export default function OrganizationRequestAccessPage() {
  const { OnboardOrganizationApi } = useApiClients();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('search') ?? '';
  const currentPage = Number(searchParams.get('page')) || 1;
  const limit = Number(searchParams.get('limit')) || 10;
  const statusFilter = searchParams.get('status') as OnboardOrganizationControllerGetRequestAccessStatusEnum | null;

  const {
    data: requestAccessData,
    isLoading,
    isRefetching,
    refetch,
  } = useQuery<GetRequestAccessResponse, Error>({
    queryKey: [
      'get-organization-request-access',
      searchQuery,
      Number(currentPage),
      Number(limit),
      statusFilter,
    ],
    queryFn: async () => {
      const response =
        await OnboardOrganizationApi.onboardOrganizationControllerGetRequestAccess({
          page: Number(currentPage) || 1,
          limit: Number(limit),
          status: statusFilter || undefined,
          search: searchQuery || undefined,
        });

      return response?.data;
    },
  });

  const hasFilters = !!searchQuery || !!statusFilter;

  const noDataMessage = hasFilters
    ? 'No items match your filters or search. Try using different keywords maybe.'
    : 'No organization requests found';

  return (
    <div className="flex w-full flex-1 flex-col px-15 pt-14 pb-10 md:px-25 lg:pr-14 lg:pb-20 lg:pl-8">
      <OrganizationRequestAccess
        data={requestAccessData}
        noDataMessage={noDataMessage}
        params={{
          search: searchQuery,
          page: Number(currentPage),
          limit: Number(limit),
          status: statusFilter || undefined,
        }}
        isOrganizationsLoading={isLoading || isRefetching}
        refetch={refetch}
      />
    </div>
  );
}

